/*

Browsers limit cookies to 4 kB. If you need to store more than 4 kB on the 
client, you should use local storage.

*/

export const setCookie = (id, value, expire) => {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + expire)
  document.cookie =
    id +
    "=" +
    escape(value) +
    (expire === null ? "" : ";expires=" + exdate.toUTCString())
}

export const setCookieInHours = (id, value, expireInHours) => {
  const exp = new Date(new Date().getTime() + 3600 * 1000 * expireInHours)

  document.cookie =
    id + "=" + value + "; expires=" + exp.toUTCString() + "; path=/"
}

export const getCookie = (cname) => {
  var name = cname + "="
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(";")
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === " ") {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return undefined
}
